import { render } from "./CitizensTourism.vue?vue&type=template&id=5050bcf2"
import script from "./CitizensTourism.vue?vue&type=script&lang=js"
export * from "./CitizensTourism.vue?vue&type=script&lang=js"

import "./CitizensTourism.vue?vue&type=style&index=0&id=5050bcf2&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__